export default __webpack_public_path__ + "static/explore_2-d1431305dce3edd7412f2f2216defb9e.png";